import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDraggable } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
// Components
import { EmotionalQuestion, CheckDiv, CheckImg, QuestionText } from "./styles";
// Assets
import CheckIco from "../../../../../assets/images/ico_check.png";

const EmotionalQuestions = ({ emotionalQuestion, checkBackgroundColor, isDisabledInputs, isPatientEmotionalQuestion }) => {
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [t] = useTranslation("global");

  const { transform, transition } = useDraggable({ id: emotionalQuestion.EMOTIONAL_QUESTION_ID });
  const { attributes, listeners, setNodeRef } = useSortable({ id: emotionalQuestion.EMOTIONAL_QUESTION_ID });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const questionText = t(`questionnaires_emotionalQuestions_${emotionalQuestion.EMOTIONAL_QUESTION_KEY}`);

  return (
    <>
      {questionText && (
        <EmotionalQuestion
          style={style}
          ref={setNodeRef}
          {...attributes}
          {...listeners}
          onMouseDown={() => setIsMouseDown(true)}
          onMouseUp={() => setIsMouseDown(false)}
          onMouseLeave={() => setIsMouseDown(false)}
          cursor={isMouseDown ? "grabbing" : "grab"}
          isDisabledInputs={isDisabledInputs}
        >
          <CheckDiv background={checkBackgroundColor}>{isPatientEmotionalQuestion && <CheckImg src={CheckIco} alt="ico-check" />}</CheckDiv>
          <QuestionText>{questionText}</QuestionText>
        </EmotionalQuestion>
      )}
    </>
  );
};

export default EmotionalQuestions;
